import React, { type FunctionComponent } from 'react'
import { type GetCollectionQuery } from 'domains/collections/api'
import { useTaxonomyNodes } from 'api/taxonomy-nodes/useTaxonomyNodes.hooks'
interface Props {
  subject: GetCollectionQuery['collection']['subjects'][0]
}

const productCategories = [
  'l1CategoryId',
  'l2CategoryId',
  'l3CategoryId',
  'l4CategoryId',
  'l5CategoryId',
  'l6CategoryId',
] as const

export const collectionsViewRuleIsProductCategory = (
  rule: GetCollectionQuery['collection']['subjects'][0]
): boolean =>
  productCategories.map(productCategory => rule[productCategory].length > 0).includes(true)

export const CollectionsViewRuleProductCategory: FunctionComponent<Props> = ({ subject }) => {
  const { getTaxonomyNodePath, taxonomyNodes } = useTaxonomyNodes()

  if (!taxonomyNodes) return null

  const productCategoryIds: string[] = productCategories.reduce(
    (allIds, productCategory) => [...allIds, ...subject[productCategory]],
    []
  )

  return (
    <div data-testid={`collections-view-rule-product-categories-${subject.id}`}>
      {productCategoryIds.map(productCategoryId => (
        <span key={productCategoryId}>
          {getTaxonomyNodePath(parseInt(productCategoryId))
            ?.map(node => node.name)
            .join(' > ')}
        </span>
      ))}
    </div>
  )
}
